import React from 'react';
import medicalTourismPackageData from '../../../StaticData/medicalTourismPackage.json';
import PackageCard from '../../../UI/UIComponent/packageCardView/PackageCard';
import './globalHealthPack.scss';

export default function GlobalHealthCarePackage(props) {
  const ImgPath = require.context('../../../assets/Images/medicalTourism/', true);
  return (
    <div className='healthPack-component container'>
      <div className="heading">
        <h1>Global Health Care Packages</h1>
        <p>
          We bring trusted healthcare to your doorstep with nursing,
          physiotherapy, diagnostics, medical equipment, and 24×7 emergency
          support—so you and your loved ones receive quality care in the comfort
          of home
        </p>
      </div>
      <div className='pack-items'>
          {
            medicalTourismPackageData.map((data,index)=>(
                <PackageCard cardContent={data.content} imagesrc={ImgPath(`./${data.image}.png`)} onKnowMoreClick={props.onKnowMoreClick}></PackageCard>
            ))  
          }
      </div>
    </div>
  )
}
